import take from "../take.js";
export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_dropLast.js
// module id = 1306
// module chunks = 1